import React from 'react';

type TDimensions = [width: number, height: number];

interface IImageContent {
    images: string | string[];
    imageDimensions: TDimensions | TDimensions[];
}

/**
 * Используется для добавления изображений в список.
 *
 * Изображения в формате PNG экспортируются из макетов в разрешении х3 от необходимого для лучшего качества,
 * в связи с этим необходимо указывать целевые размеры изображения
 *
 * @param images
 * @param imageDimensions
 * @constructor
 */
export const ImageContent = ({ images, imageDimensions }: IImageContent) => {
    const contentItems: string[] = Array.isArray(images) ? images : [images];
    const contentDimensions: number[][] = Array.isArray(imageDimensions[0])
        ? (imageDimensions as TDimensions[])
        : ([imageDimensions] as TDimensions[]);

    return (
        <div className="imageContent">
            {contentItems.map((item, index) => {
                const [width, height] = contentDimensions[index];

                return (
                    <img
                        width={width}
                        height={height}
                        className="imageContentItem"
                        src={item}
                        key={item}
                        alt={item}
                    />
                );
            })}
        </div>
    );
};
